import { useMsal } from '@azure/msal-react'
import React from 'react'
import {
  RequestToken,
  getMyPhoto,
  getUserDetails,
  getUserInitials,
} from '../../../core/authentication'

import { UserType } from '../../../core/user-context/user-context-middleware'
import { getUserEmail } from '../../utils/utils'

const useUserDetails = (): {
  authData: UserType
  isLoading: boolean
} => {
  const [authData, setAuthData] = React.useState<UserType>({})
  const [isLoading, setIsLoading] = React.useState(true)
  const { instance, accounts } = useMsal()

  const getMyProfile = async () => {
    try {
      const accessToken = await RequestToken(instance, accounts)
      if (accessToken) {
        const user = await getUserDetails('me', accessToken)
        const photo = await getMyPhoto(accessToken)

        setAuthData({
          accessToken,
          photo,
          userDisplayName: user.displayName,
          userEmail: getUserEmail(user.userPrincipalName, user.mail),
          userPhoto: photo,
          userInitials: getUserInitials(
            user.givenName as string,
            user.surname as string
          ),
          userJobTitle: user.jobTitle,
          userOfficeLocation: user.officeLocation,
          userId: user.id,
        })
        setIsLoading(false)
      }
    } catch (err) {
      console.error(err)
    }
  }

  React.useEffect(() => {
    getMyProfile()
  }, [])

  return { authData, isLoading }
}
export default useUserDetails
